import React from "react"
import { Button, Modal, ModalBody } from "@silversea-ssc/ui-components-react"
import { DemetraPayment } from "@ssc-booking/api-contracts"
import DemetraPay from "../../app-core/features/payment/components/DemetraPay"
import styles from "./DemetraPaymentModal.module.scss"
import { ResizableIFrame } from "./ResizableIFrame"

type Props = {
    payment: DemetraPayment
    iframeName: string
    closeModal: () => void
}

export const DemetraPaymentModal: React.FC<React.PropsWithChildren<Props>> = ({ payment, iframeName, closeModal }) => {
    return (
        <Modal
            size="medium"
            modal={{
                isOpen: true,
                shouldCloseOnEsc: false,
                shouldCloseOnOverlayClick: false,
            }}
            dataContentName="payment_modal"
        >
            <ModalBody variant="full" className={styles.bodyWrapper}>
                <div className={styles.header}>
                    <Button
                        renderAs="button"
                        variant="inline-text"
                        size="regular"
                        iconName="close"
                        dataContentPiece="close-modal"
                        onClick={closeModal}
                    />
                </div>

                <div className={styles.body}>
                    <DemetraPay target={iframeName} payment={payment} />
                    <ResizableIFrame name={iframeName} id="cardinal_collection_iframe" className={styles.iframe} />
                </div>
            </ModalBody>
        </Modal>
    )
}
